import { useSelector } from 'react-redux'
import { selectUser, selectUserPagesCache } from '../redux/systemSlice'

const FREE_TRIAL_ESSAY_LIMIT = 1

const useTrialEssayCredits = () => {
	const user = useSelector(selectUser)
	const userPagesCache = useSelector(selectUserPagesCache)

	const isOnFreeTrial = !!user?.isOnFreeTrial
	const essaysUsed = userPagesCache?.pages?.length ?? 0
	const essaysRemaining = Math.max(0, FREE_TRIAL_ESSAY_LIMIT - essaysUsed)

	return {
		isOnFreeTrial,
		essaysRemaining,
		essayLimit: FREE_TRIAL_ESSAY_LIMIT,
		hasCredits: essaysRemaining > 0,
	}
}

export default useTrialEssayCredits
